(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products-gk"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.fp-gk');

    sections.forEach(function(section) {
      const track = section.querySelector('[data-carousel-track]');
      const prev = section.querySelector('[data-carousel-prev]');
      const next = section.querySelector('[data-carousel-next]');

      if (!track || !prev || !next) return;

      function getStep() {
        const card = track.querySelector('.fp-gk__card');
        if (!card) return 320;
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.gap) || 16;
        return card.offsetWidth + gap;
      }

      prev.addEventListener('click', function() {
        track.scrollBy({ left: -getStep() * 2, behavior: 'smooth' });
      });

      next.addEventListener('click', function() {
        track.scrollBy({ left: getStep() * 2, behavior: 'smooth' });
      });

      // Hide nav arrows when there's nothing to scroll
      function updateNavVisibility() {
        const canScrollLeft = track.scrollLeft > 4;
        const canScrollRight = track.scrollLeft < (track.scrollWidth - track.clientWidth - 4);
        prev.style.opacity = canScrollLeft ? '1' : '0.3';
        prev.style.pointerEvents = canScrollLeft ? 'auto' : 'none';
        next.style.opacity = canScrollRight ? '1' : '0.3';
        next.style.pointerEvents = canScrollRight ? 'auto' : 'none';
      }

      track.addEventListener('scroll', updateNavVisibility, { passive: true });
      window.addEventListener('resize', updateNavVisibility);
      updateNavVisibility();

      // AJAX Add to Cart for single-variant products
      section.querySelectorAll('[data-fp-add]:not([data-bound])').forEach(function(btn) {
        btn.setAttribute('data-bound', 'true');
        btn.addEventListener('click', async function(e) {
          e.preventDefault();
          var variantId = btn.dataset.variantId;
          if (!variantId) return;

          var originalLabel = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          try {
            var res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
            });
            if (!res.ok) throw new Error('Add failed');

            btn.textContent = '✓ Added';
            btn.classList.add('is-added');

            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { variantId: variantId } }));

            setTimeout(function() {
              btn.textContent = originalLabel;
              btn.classList.remove('is-added');
              btn.disabled = false;
            }, 1800);
          } catch (err) {
            console.error('[fp-gk] Add to cart failed:', err);
            btn.textContent = 'Try Again';
            setTimeout(function() {
              btn.textContent = originalLabel;
              btn.disabled = false;
            }, 1800);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-1"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var headers = document.querySelectorAll('[data-header]');
    headers.forEach(function(header) {
      var toggle = header.querySelector('[data-mobile-toggle]');
      var drawer = header.querySelector('[data-mobile-drawer]');
      var overlay = header.querySelector('[data-drawer-overlay]');
      if (!toggle || !drawer) return;

      function openDrawer() {
        drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('header-gk-drawer-open');
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('header-gk-drawer-open');
      }

      toggle.addEventListener('click', function() {
        var isOpen = drawer.classList.contains('is-open');
        if (isOpen) closeDrawer(); else openDrawer();
      });

      // Close when overlay tapped
      if (overlay) {
        overlay.addEventListener('click', closeDrawer);
      }

      // Close on Escape
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeDrawer();
          toggle.focus();
        }
      });

      // Close drawer when a nav link (not a submenu toggle) is clicked
      drawer.querySelectorAll('a').forEach(function(link) {
        link.addEventListener('click', closeDrawer);
      });

      // Submenu accordion toggles
      drawer.querySelectorAll('[data-submenu-toggle]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        });
      });

      // Close drawer if window resizes back to desktop
      var mql = window.matchMedia('(min-width: 991px)');
      mql.addEventListener('change', function(e) {
        if (e.matches && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-3"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();
})();
